module.exports = __webpack_public_path__ + "img/image-instructionsgo.2f815d17.svg";